import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './Common.module.css';
import { AlSection, AlSpeechTestRow } from 'PatientCareCenter/Note/AL';
import { codeValidForAdmit } from '_helpers';
import { CancelButton, StatusGood } from '_components';
class AlSpeechTest extends React.Component {

    constructor(props) {
        super();
        this.state = {
            showWarning: false
        };
    }

    add() {
        if (this.props.trtValid || (!this.props.trtValid && this.props.speechTests.length > 0)) {
            this.props.addAlRow(this.props.noteId, 'MLSPEECH', 'XLSP', 'XLSPNO', 'XLSPXLNO', this.props.xlno, 'NEW_XLSPNO');
            this.setState({ showWarning: false });
        } else if (!this.props.trtValid && this.props.speechTests.length === 0) {
            this.setState({ showWarning: true });
        }
    }

    componentDidUpdate() {
        if (this.props.speechTests.length === 0 && this.props.time !== null) {
            this.props.clearFields(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, ['XLTIMESPEECH', 'XLTIMESPEECHASSIST', 'XLTIMESPEECHTHERAPIST']);
        }
    }

    confirmPending() {
        this.props.addAlRow(this.props.noteId, 'MLSPEECH', 'XLSP', 'XLSPNO', 'XLSPXLNO', this.props.xlno, 'NEW_XLSPNO');
        this.setState({ showWarning: false });
    }

    remove() {
        this.setState({ showWarning: false });
    }
    render() {
        return (
            <AlSection
                id='al_speech'
                name='Speech (92507)'
                timeField='XLTIMESPEECH'
                timeRequired={this.props.containsPerformed && this.props.time === null ? true : false}
                timeVisible={this.props.speechTests.length > 0 ? true : false}
                trackAssist={this.props.trackAssist}
                onAdd={() => this.add()}
                className={this.props.className}
            >
                 {this.state.showWarning &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.warning_msg}>This treatment code is not covered by the patient's payer and will <b>not</b> be reimbursed.  Do you wish to add it anyway?</span>
                        <span className={styles.yes_button} >
                            <StatusGood size='extra-small' title='Yes' onClick={() => this.confirmPending()} />
                        </span>
                        <span className={styles.no_button} >
                            <CancelButton size='extra-small' title='No' onClick={() => this.remove()} />
                        </span>
                    </div>
                }

                {this.props.speechTests.length > 0 &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.col1_header}>Activity</span>
                        <span className={styles.col2_expansive_header}>Description</span>
                        <span className={styles.col6_header}>Reps/Percentage/# of trials</span>
                        <span className={styles.col4_header}>Performed</span>
                    </div>
                }
                {Object.keys(this.props.speechTests)
                    .map(key => {
                        const result = this.props.speechTests[key];
                        return (
                            <AlSpeechTestRow key={result.XLSPNO} id={result.XLSPNO} />
                        )
                    })
                }
            </AlSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addAlRow: bindActionCreators(noteActions.addAlRow, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let trackAssist = state.entities.admissions[epno].contractTracksAssistant;
    let isLicensed = state.entities.authentication.user.islicensed;
    let containsPerformed = state.entities.notes.MLSPEECH &&
        Object.keys(state.entities.notes.MLSPEECH)
            .filter(key => {
                return (state.entities.notes.MLSPEECH[key].XLSPXLNO === xlno && state.entities.notes.MLSPEECH[key].XLSPPERFORMED)
            }).length > 0 ? true : false;

    return {
        noteId,
        xlno,
        time: state.entities.notes.MLEXLOG[xlno].XLTIMESPEECH,
        trtValid: codeValidForAdmit(epno, '92507'),
        speechTests: Object.keys(state.entities.notes.MLSPEECH)
            .filter(key => {
                return (state.entities.notes.MLSPEECH[key].XLSPXLNO === xlno)
            })
            .sort((a, b) => state.entities.notes.MLSPEECH[a].XLSPNO - state.entities.notes.MLSPEECH[b].XLSPNO)
            .map(key => state.entities.notes.MLSPEECH[key]),
        trackAssist,
        isLicensed,
        containsPerformed
    };
}

const connectedAlSpeechTest = connect(mapStateToProps, mapDispatchToProps)(AlSpeechTest);
export { connectedAlSpeechTest as AlSpeechTest };

